import type { ReceiptTemplate } from '../schema';

export const shakeShackTemplate: ReceiptTemplate = {
  id: 'shake-shack',
  name: 'Shake Shack Receipt',
  brand: 'SHAKE SHACK',
  description: 'Shake Shack restaurant receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'ss-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/shake-shack.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'MADISON SQUARE PARK',
          '23RD ST & MADISON AVE',
          'NEW YORK, NY 10010',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ss-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER #847',
        fontSize: 20,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'ss-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'DINE IN\n01/04/26 12:45  SERVER: ALEX',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ss-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'ss-item-1', name: 'SHACKBURGER', quantity: '1', price: '7.99'},
          { id: 'ss-item-2', name: 'CRINKLE CUT FRIES', quantity: '1', price: '3.99'},
          { id: 'ss-item-3', name: 'SHACK ATTACK', quantity: '1', price: '6.49'},
          { id: 'ss-item-4', name: 'SHACK-CAGO DOG', quantity: '1', price: '5.99'},
          { id: 'ss-item-5', name: 'FIFTY/FIFTY', quantity: '2', price: '7.98'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ss-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'ss-subtotal', label: 'SUBTOTAL', value: '32.44', isBold: false, isLarge: false },
          { id: 'ss-tax', label: 'TAX', value: '2.88', isBold: false, isLarge: false },
          { id: 'ss-total', label: 'TOTAL', value: '35.32', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'ss-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'ss-card', label: 'AMEX', value: '***********84747' },
          { id: 'ss-auth', label: 'AUTH', value: '284791' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'ss-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'SS847010426124',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ss-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'STAND FOR SOMETHING GOOD\n\nTHANK YOU!',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
